<template>
  <div :class="$style.pdfPreview">
    <SCAIconButton
      :class="$style.mobileCloseButton"
      appearance="inverted"
      type="ghost"
      size="xsmall"
      icon="phosphor/x"
      @click="$emit('close')"
    />
    <iframe :src="fileUrl" frameborder="0" allow="fullscreen" />
  </div>
</template>

<script lang="ts" setup>
import { SCAIconButton } from "@scayla/components";

defineProps<{
  fileUrl: string;
}>();

defineEmits(["close"]);
</script>

<style lang="scss" module>
.pdfPreview {
  height: 100%;
  position: relative;
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.mobileCloseButton {
  position: absolute;
  top: var(--dimension-200);
  left: var(--dimension-150);
  z-index: 2;
  display: none;
  width: var(--dimension-300) !important;
  height: var(--dimension-300) !important;

  @media (max-width: 478px) {
    display: inline-flex;
  }
}
</style>
